export const config = {
    // Usa variables de entorno o valores por defecto
    // En desarrollo local, puedes crear un archivo .env con REACT_APP_SERVER_URL
    // En producción, se establecen según la rama en GitHub Actions
    serverUrl: process.env.REACT_APP_SERVER_URL || 'http://localhost:3000',
    analyzer: process.env.REACT_APP_ANALYZER_URL || 'http://127.0.0.1:5000',
};